module.exports = __webpack_public_path__ + "img/reservationFormSmall.9c5bf321.svg";